import React from 'react';

function appendScript(baseUrl, setScriptLoaded, setLoadError) {
    if (window.MktoForms2) return setScriptLoaded(true);

    const onLoad = () => (window.MktoForms2 ? setScriptLoaded(true) : null);
    const onError = () => setLoadError(true);

    const script = document.createElement('script');
    script.src = `${baseUrl}/js/forms2/js/forms2.min.js`;
    script.async = true;
    script.addEventListener('load', onLoad);
    script.addEventListener('error', onError);
    document.body.appendChild(script);
}

export function addChiliPiper() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://js.chilipiper.com/marketing.js';
    script.async = true;
    document.body.appendChild(script);
    const script2 = document.createElement('script');
    const router = 'inbound-router1';
    script2.textContent = `function q(a){return function(){ChiliPiper[a].q=(ChiliPiper[a].q||[]).concat([arguments])}}window.ChiliPiper=window.ChiliPiper||"submit scheduling showCalendar submit widget bookMeeting".split(" ").reduce(function(a,b){a[b]=q(b);return a},{}); ChiliPiper.scheduling("themuse", "${router}", {title: "Thanks! What time works best for a quick call?", map:true, formId: "mktoForm_1468"})`;
    document.head.appendChild(script2);
}

export default function useMarketo({ baseUrl, munchkinId, formId, callback }) {
    const [scriptLoaded, setScriptLoaded] = React.useState(false);
    const [loadError, setLoadError] = React.useState(false);

    React.useEffect(() => {
        if (scriptLoaded) {
            window.MktoForms2.loadForm(baseUrl, munchkinId, formId, callback);
            window.MktoForms2.whenReady((form) => {
                form.onSuccess( (values, followUpUrl) => {
                    // .marketo-form set to display none
                    const formContainer = document.querySelector('.component-Modals-ModalManager');
                    formContainer.style.display = 'none';
                    return false;
                });
            });
            addChiliPiper();
            return;
        }

        appendScript(baseUrl, setScriptLoaded, setLoadError);
    }, [scriptLoaded, baseUrl, munchkinId, formId, callback]);

    return [scriptLoaded, loadError];
}


